import React from 'react'
import {Box, Typography} from '@mui/material'

function StepContainer({children, number}) {
    return (
        <Box sx={{marginTop: '20px', display: 'flex', flexDirection: 'row'}}>
            <Box sx={{width: '25px', height:'25px', backgroundColor: '#0355A1', borderRadius: "15px", display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
                <Typography sx={{color: 'white'}} fontWeight={'Bold'}>{number}</Typography>
            </Box>
            <Typography sx={{marginLeft: '10px'}}>{children}</Typography>
        </Box>
    )
}

export default StepContainer